const data = [
    { id: 1, name: 'Justiça Comum' },
    { id: 2, name: 'Justiça do Trabalho' },
    { id: 3, name: 'Justiça Federal' }
    
]
  
export default [...data]
  